import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  isOpen: boolean;
}

export const UnsavedChangesModal = ({ onConfirm, onClose, isOpen }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      onSubmit={onConfirm}
      titleProps={{
        title: t("general.unsavedChanges.title"),
        size: "large",
      }}
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        confirm: {
          buttonText: t("general.closeAnyway"),
          buttonActionType: "submit",
        },
        cancel: {
          buttonText: t("general.continueEditing")
        },
      }}
    >
      <div>
        <Text>{t("general.unsavedChanges.description")}</Text>
      </div>
    </Modal>
  );
};
